import React from "react";
import LoadingSpinner from "@/components/common/spinner/Spinner";
import AlertMessage from "@/components/layout/message/AlertMessage";
import "./DashboardMain.module.css";
import { baseSectionsConfig } from "./DashboardSectionConfig";
import type { dashboardMainProps } from "./types.props";

const DashboardMain: React.FC<dashboardMainProps> = (props) => {
    const {
        isLoading,
        error,
        dashboardData,
        disabledSections = [],
        extraSections = [],
    } = props;

    if (isLoading && !dashboardData) {
        return <LoadingSpinner text="Cargando datos del dashboard..." />;
    }

    if (error) {
        return (
            <AlertMessage type="error" title="Error en el dashboard">
                {error.generalMessage}
            </AlertMessage>
        );
    }

    const allSections = [...baseSectionsConfig, ...extraSections];

    const activeSections = allSections.filter(
        (section) => section.isFixed || !disabledSections.includes(section.id),
    );

    return (
        <div className="dashboard-grid">
            {activeSections.map((section) => {
                const SectionComponent = section.component;
                const dynamicProps = section.getProps(props);
                const staticProps = section.extraProps || {};

                const sectionProps = { ...dynamicProps, ...staticProps };

                if (Object.values(dynamicProps).some(prop => prop === undefined || prop === null)) {
                    return null;
                }

                return (
                    <section id={section.id} key={section.id}>
                        <SectionComponent {...sectionProps} />
                    </section>
                );
            })}
        </div>
    );
};

export default DashboardMain;
